import React from 'react';

function CatalogueHeader({ title }) {
  return (
    <div className="catalogue-header">
      <h1 className="catalogue-title">{title}</h1>
    </div>
  );
}

export default CatalogueHeader;
